export default {
  payrolls: [],
  pendingPayrolls: []
}
